function clone<T>(value: T): T { return structuredClone(value); }

export function setAtPath<T>(value: T, path: string, nextValue: unknown): T {
  const result = clone(value);
  const parts = path.split(".");
  let cursor: unknown = result;
  for (let index = 0; index < parts.length - 1; index += 1) {
    if (!cursor || typeof cursor !== "object") throw new Error(`Cannot update ${path}`);
    cursor = (cursor as Record<string, unknown>)[parts[index]];
  }
  if (!cursor || typeof cursor !== "object") throw new Error(`Cannot update ${path}`);
  (cursor as Record<string, unknown>)[parts.at(-1)!] = nextValue;
  return result;
}
